import { useEffect, useState, useRef, useMemo } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Select from 'react-select';

function EmergencyRegistrations() {
    const [ldata, setLdata] = useState(null);
    const [headerLogo, setHeaderLogo] = useState('');
    const [isSaved, setIsSaved] = useState(false);
    const [uhidSuggestions, setUhidSuggestions] = useState([]);
    const [formData, setFormData] = useState({
      // lists / lookups
      cats: [],        // specialities
      docs: [],        // doctors
      cases: [],       // case list
      vitals: [],
  
      // primary emergency fields
      ipd_id: '',
      ipd_uhid: '',
  
      // patient identity
      ipd_patient_title: 'Mr.',
      ipd_patient_name: '',
      ipd_patient_gender: 'Male',
      ipd_patient_mobile: '',
      ipd_guardien_title: '',
      ipd_guardien_name: '',
  
      // address
      ipd_address: '',
      ipd_city_text: '',
      ipd_country: 'India',
      ipd_state: '',
      ipd_district: '',
  
      // demographic
      ipd_age_year: '',      // Changed from ipd_age
      ipd_age_month: '',     // New field
      ipd_age_day: '',       // New field
      ipd_religion: '',
      ipd_occupation: '',
      ipd_nature_of_injury: '',
      body_part_affected: '',
  
      // clinical
      ipd_type: '',
      ipd_specality: '',
      ipd_refer_doctor: '',
      ipd_refer_doctor_name: '',
      ipd_file_number: '',
      ipd_attachment: null,
      ipd_reg_date: '',
      ipd_datetime: '',
  
      // case
      ipd_case: '',
      ipd_case_name: '',
  
      // pricing & payments
      ipd_price: '',
      ipd_total_price: '',
      ipd_discount: '',
      ipd_reg_charges: '',
      ipd_reg_charges_original: '',
      ipd_paid: '',
      ipd_due: '',
      ipd_pay_mode: 'cash',
      ipd_remarks: '',
  
      // control/alerts
      ipd_user: '',
      page_no: 0,
      alertMsg: '',
      alertMsgTyp: '',
      search_key: '',
      isAlert: false,
  });

    // Refs for react-select
    const specRef = useRef();
    const docRef = useRef();
    const caseRef = useRef();

    useEffect(() => {
        const now = new Date();
        setFormData(prev => ({
            ...prev,
            ipd_reg_date: now.toISOString().slice(0,10),
        }));
    }, []);

    // Auto-generate file number
    // Auto-generate file number - EMR with only 4 random digits
const generateFileNumber = () => {
  const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
  return `EMR${random}`;
};

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => {
            let updatedData = {
                ...prev,
                [name]: value
            };

            if (name === "ipd_discount") {
                const discountPercent = parseFloat(value) || 0;
                const regOriginal = parseFloat(prev.ipd_reg_charges_original) || parseFloat(prev.ipd_reg_charges) || 0;
                const discountedReg = Math.max(0, regOriginal * (1 - (discountPercent / 100)));
                updatedData.ipd_reg_charges = discountedReg.toFixed(2);
                updatedData.ipd_discount = value;
            }
            else if (name === "ipd_patient_title") {
                if(value === "Mr." || value === "Master"){
                    updatedData.ipd_patient_gender = "Male";
                } else {
                    updatedData.ipd_patient_gender = "Female";
                }
            }
            else if (name === "search_key") {
                initData();
            }
            else if (name === "ipd_type") {
                if (value === "Old") {
                    updatedData.ipd_reg_charges = 0;
                } else {
                    updatedData.ipd_reg_charges = prev.ipd_reg_charges;
                }
            }

            return updatedData;
        });
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
  
      // ensure gender exists
      setFormData(prev => {
          let gender = prev.ipd_patient_gender;
          const title = (prev.ipd_patient_title || '').toLowerCase();
          if (!gender) {
              if (title.includes('mr') || title.includes('master')) gender = 'Male';
              else if (title.includes('miss') || title.includes("mrs") || title.includes('baby') || title.includes('ms')) gender = 'Female';
              else gender = 'Other';
          }
          return { ...prev, ipd_patient_gender: gender };
      });
  
      // validation
      if (!formData.ipd_patient_name || formData.ipd_patient_name.trim() === '') {
          toast.error('Patient name required');
          return;
      }
  
      const fd = new FormData();
  
      // basic fields
      fd.append('ipd_patient_title', formData.ipd_patient_title || '');
      fd.append('ipd_patient_name', formData.ipd_patient_name || '');
      fd.append('ipd_patient_gender', formData.ipd_patient_gender || '');
      fd.append('ipd_patient_mobile', formData.ipd_patient_mobile || '');
      fd.append('ipd_guardien_title', formData.ipd_guardien_title || '');
      fd.append('ipd_guardien_name', formData.ipd_guardien_name || '');
      fd.append('ipd_address', formData.ipd_address || '');
      fd.append('ipd_city', formData.ipd_city_text || '');
      fd.append('ipd_district', formData.ipd_district || '');
      fd.append('ipd_state', formData.ipd_state || '');
      fd.append('ipd_country', formData.ipd_country || '');
      
      // Age fields
      fd.append('ipd_age_year', formData.ipd_age_year || '');
      fd.append('ipd_age_month', formData.ipd_age_month || '');
      fd.append('ipd_age_day', formData.ipd_age_day || '');
      
      fd.append('ipd_religion', formData.ipd_religion || '');
      fd.append('ipd_occupation', formData.ipd_occupation || '');
      fd.append('ipd_nature_of_injury', formData.ipd_nature_of_injury || '');
      fd.append('body_part_affected', formData.body_part_affected || '');
      
      // case
      fd.append('ipd_case', formData.ipd_case || '');
      
      // payment fields
      fd.append('ipd_price', formData.ipd_price || 0);
      fd.append('ipd_total_price', formData.ipd_total_price || 0);
      fd.append('ipd_discount', formData.ipd_discount || 0);
      fd.append('ipd_reg_charges', formData.ipd_reg_charges || 0);
      fd.append('ipd_paid', formData.ipd_paid || 0);
      fd.append('ipd_due', formData.ipd_due || 0);
      fd.append('ipd_pay_mode', formData.ipd_pay_mode || 'cash');
      fd.append('ipd_remarks', formData.ipd_remarks || '');
      
      // clinical
      fd.append('ipd_type', formData.ipd_type || '');
      fd.append('ipd_specality', formData.ipd_specality || '');
      fd.append('ipd_refer_doctor', formData.ipd_refer_doctor || '');
      fd.append('ipd_file_number', formData.ipd_file_number || '');
      
      // ipd_id if updating
      if (formData.ipd_id) fd.append('ipd_id', formData.ipd_id);
  
      // File
      if (formData.ipd_attachmentFile) {
          fd.append('ipd_attachment', formData.ipd_attachmentFile);
      }
  
      // UHID
      if (formData.ipd_uhid) fd.append('ipd_uhid', formData.ipd_uhid);
  
      try {
          const url = AppConst.BASE_URL + AppConst.addEmergencyUrl;
          const response = await axios.post(url, fd, {
              headers: { 'Content-Type': 'multipart/form-data' }
          });
  
          if (response.data.status) {
              setFormData(prev => ({
                  ...prev,
                  ipd_uhid: response.data.emergency_dt?.ipd_uhid || prev.ipd_uhid,
              }));
              setIsSaved(true);
              toast.success('Registration Successful');
  
              // Auto-generate and print invoice
              (async () => {
                  const key = response.data.emergency_dt?.ipd_id ? { ipd_id: response.data.emergency_dt.ipd_id } :
                              response.data.emergency_dt?.ipd_uhid ? { ipd_uhid: response.data.emergency_dt.ipd_uhid } : {};
                  if (Object.keys(key).length === 0) return;
                  const full = await fetchEmergencyRecord(key);
                  if (full && full.emergency_dt) {
                      const admissionData = mapServerToAdmissionData(full.emergency_dt);
                      generateAdmissionPdf(admissionData);
                  }
              })();
          } else {
              toast.error(response.data.success || 'Failed');
          }
      } catch (err) {
          console.error('Submit error', err);
          toast.error('Submit failed');
      }
  };

    // load doctor list
 // Replace your existing initData1 function with this:
const initData1 = async () => {
  const storedData = sessionStorage.getItem("ldata");
  if (storedData) {
      const parsed = JSON.parse(storedData);

      const fd2 = new FormData();
      fd2.append('type', "doctor");
      fd2.append('search_key', "");
      fd2.append('page_no', "none");
      fd2.append('doc_specality', formData.ipd_specality);  // Read directly from formData
      fd2.append('user_cre_by', 1 + "");
      
      try {
          const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd2, {
              headers: {
                  'Content-Type': 'multipart/form-data',
              },
          });
          if (response.data.status) {
              var records = response.data.records;
              if (records != null && records != undefined) {
                  setFormData(prev => ({
                      ...prev,
                      docs: records
                  }));
              }
          }
      } catch (error) {
          console.error('Error loading doctors:', error);
      }
  }
}

// Replace your existing useEffect with this simpler version:
useEffect(() => {
  initData1();
}, [formData.ipd_specality]);
    // initData loads cats, cases, Emergency Fees
    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);

            // Load specialities
            const fd0 = new FormData();
            fd0.append('cat_type', "speciality");
            fd0.append('page_no', "none");
            fd0.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd0, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            cats: records
                        }));
                    }
                }
            } catch (error) {
                console.error(error);
            }

            // Load Emergency Fees
            const fd00 = new FormData();
            fd00.append('cat_type', "hospCharge");
            fd00.append('cat_name', "Emergency Fees");
            fd00.append('page_no', "none");
            fd00.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd00, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records != undefined && records.length > 0) {
                        const regBase = parseFloat(records[0].cat_type1) || 0;
                        setFormData(prev => ({
                            ...prev,
                            ipd_reg_charges: regBase.toFixed(2),
                            ipd_reg_charges_original: regBase,
                        }));
                    }
                }
            } catch (error) {
                console.error(error);
            }

            // Load cases
            try {
                const fd06w = new FormData();
                fd06w.append('cat_type', "case");
                fd06w.append('page_no', "none");
                fd06w.append('par_by', 1 + "");
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd06w, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    const records = Array.isArray(response.data.records) ? response.data.records : [];
                    if (records.length) {
                        setFormData(prev => ({
                            ...prev,
                            cases: records
                        }));
                    } else {
                        setFormData(prev => ({ ...prev, cases: [] }));
                    }
                }
            } catch (error) {
                console.error("Error loading case categories:", error);
                setFormData(prev => ({ ...prev, cases: [] }));
            }
        }
    };

    // Fetch emergency record
    const fetchEmergencyRecord = async ({ ipd_id = '', ipd_uhid = '' } = {}) => {
        try {
            const fd = new FormData();
            if (ipd_id) fd.append('ipd_id', ipd_id);
            else if (ipd_uhid) fd.append('ipd_uhid', ipd_uhid);

            const res = await axios.post(AppConst.BASE_URL + AppConst.getEmergencyByIdUrl, fd, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (res?.data?.status) {
                return res.data;
            } else {
                console.warn('fetchEmergencyRecord: no record', res?.data);
                return null;
            }
        } catch (err) {
            console.error('fetchEmergencyRecord error', err);
            return null;
        }
    };

    // Map server data to admission data
   // Map server data to admission data
const mapServerToAdmissionData = (emergency_dt) => {
  const safe = (k) => (emergency_dt && emergency_dt[k] !== undefined ? emergency_dt[k] : '');
  const regCharges = parseFloat(safe('ipd_reg_charges')) || 0;
  const total = parseFloat(safe('ipd_total_price')) || regCharges;

  // Format age display
  const ageYear = safe('ipd_age_year') || '';
  const ageMonth = safe('ipd_age_month') || '';
  const ageDay = safe('ipd_age_day') || '';
  
  let ageDisplay = '';
  if (ageYear) ageDisplay += `${ageYear} Y `;
  if (ageMonth) ageDisplay += `${ageMonth} M `;
  if (ageDay) ageDisplay += `${ageDay} D`;
  ageDisplay = ageDisplay.trim() || '';

  return {
      uhid: safe('ipd_uhid') || '',
      patientRegNo: safe('ipd_id') || '',
      patientName: safe('ipd_patient_name') || '',
      ageGender: `${ageDisplay} / ${safe('ipd_patient_gender') || ''}`,
      address: safe('ipd_address') || '',
      phone: safe('ipd_patient_mobile') || '',
      guardian: safe('ipd_guardien_name') || '',
      admissionDate: (safe('ipd_reg_date') || '').split(' ')[0] || '',
      referredDoctor: safe('ipd_refer_doctor_name') || safe('ipd_refer_doctor') || '',
      department: safe('ipd_specality_name') || safe('ipd_specality') || '',
      caseType: safe('ipd_case_name') || safe('ipd_case') || '',
      fileNumber: safe('ipd_file_number') || '',
      payments: [
          ['1.', 'Emergency Fees', (safe('ipd_pay_mode') || 'Cash'), (regCharges).toFixed(2)]
      ],
      summary: {
          regCharges: regCharges,
          total: total,
          discount: parseFloat(safe('ipd_discount')) || 0,
          paid: parseFloat(safe('ipd_paid')) || 0,
          due: parseFloat(safe('ipd_due')) || 0,
          final: parseFloat((total - ((parseFloat(safe('ipd_discount')) || 0) * total/100))) || total
      },
  };
};

    // fetch config/logo
    const fetchConfigData = async () => {
        try {
            const res = await axios.post(
                `${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`
            );
            if (res.data.status) {
                const data = res.data;
                setHeaderLogo(data.header_logo);
            }
        } catch (err) {
            console.error("Error fetching config:", err);
        }
    };

    useEffect(() => {
        fetchConfigData();
    }, []);

    const imageUrlToBase64 = async (url) => {
        if (!url) return null;
        try {
            const response = await fetch(url);
            if (!response.ok) return null;
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error converting image to Base64:", error);
            return null;
        }
    };

    const findNameById = (id, array, idField, nameField) => {
        if (!id || !Array.isArray(array)) return '';
        const item = array.find(i => i[idField] == id);
        return item ? item[nameField] : '';
    };

    const generateAdmissionPdf = async (data) => {
        const doc = new jsPDF('p', 'pt', 'a4');
        const pageWidth = doc.internal.pageSize.getWidth();
        const margin = 40;
        let y = 0;

        const headerImageBase64 = await imageUrlToBase64(headerLogo);

        if (headerImageBase64) {
            doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 80);
        }

        y = 90;

        // Title
        doc.setFontSize(12);
        doc.setFont('helvetica', 'normal');
        doc.setDrawColor(0);
        doc.rect(margin, y, pageWidth - (margin * 2), 25);
        doc.text("Emergency / DayCare Patient Invoice", pageWidth / 2, y + 16, { align: 'center' });
        y += 45;

        // Patient Details
        doc.setFontSize(10);
        const leftColX = margin + 10;
        const rightColX = pageWidth / 2 + 80;
        const labelWidth = 90;

        const printDetailLine = (label, value, x, currentY) => {
            doc.setFont('helvetica', 'normal');
            doc.text(label, x, currentY);
            doc.text(":", x + labelWidth, currentY);
            doc.setFont('helvetica', 'normal');
            doc.text(String(value || ''), x + labelWidth + 10, currentY);
        };

        let detailsY = y;
        printDetailLine("UHID No", data.uhid, leftColX, detailsY);
        printDetailLine("Patient Reg. No", data.patientRegNo, rightColX, detailsY);
        detailsY += 14;

        printDetailLine("Patient Name", data.patientName, leftColX, detailsY);
        printDetailLine("Age / Gender", data.ageGender, rightColX, detailsY);
        detailsY += 14;

        printDetailLine("Address", data.address, leftColX, detailsY);
        printDetailLine("Phone No.", data.phone, rightColX, detailsY);
        detailsY += 14;

        printDetailLine("Guardian", data.guardian, leftColX, detailsY);
        printDetailLine("Admission Date", data.admissionDate, rightColX, detailsY);
        detailsY += 14;

        printDetailLine("Referred Doctor", data.referredDoctor, leftColX, detailsY);
        printDetailLine("Department", data.department, rightColX, detailsY);
        detailsY += 14;

        printDetailLine("Case Type", data.caseType, leftColX, detailsY);
        printDetailLine("File Number", data.fileNumber, rightColX, detailsY);

        y = detailsY + 25;

        // Payment History Table
        autoTable(doc, {
            startY: y,
            head: [['Sl.No', 'Particular', 'Payment Method', 'Amount (Rs)']],
            body: data.payments,
            theme: 'grid',
            headStyles: {
                fillColor: [255, 255, 255],
                textColor: 0,
                fontStyle: 'bold',
                lineWidth: 0.5,
                lineColor: [0, 0, 0],
            },
            styles: {
                fontSize: 10,
                cellPadding: 5,
                lineWidth: 0.5,
                lineColor: [0, 0, 0]
            },
            columnStyles: {
                0: { cellWidth: 50, halign: 'center' },
                3: { halign: 'right' }
            },
            margin: { left: margin, right: margin }
        });

        let finalY = doc.lastAutoTable.finalY;

        // Summary
        finalY += 25;
        const summaryLabelColX = pageWidth - 220;
        const summaryValueColX = pageWidth - margin;

        const printSummaryLine = (label, value) => {
            doc.setFontSize(10);
            doc.setFont('helvetica', 'normal');
            doc.text(label, summaryLabelColX, finalY, { align: 'left' });
            doc.text(':', summaryLabelColX + 100, finalY);
            doc.setFont('helvetica', 'bold');
            doc.text('Rs.', summaryValueColX - 60, finalY, { align: 'left' });
            doc.text(value.toFixed(2), summaryValueColX, finalY, { align: 'right' });
            finalY += 15;
        };

        printSummaryLine("Emergency Charges", data.summary.regCharges);
        printSummaryLine("Total Amount", data.summary.total);
        printSummaryLine("Discount Amount", data.summary.discount);
        printSummaryLine("Final Amount", data.summary.final);
        printSummaryLine("Paid", data.summary.paid);
        printSummaryLine("Due", data.summary.due);

        // Authorized Signature
        const signatureLineY = finalY + 20;
        const signatureX = margin;

        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.line(signatureX, signatureLineY, signatureX + 150, signatureLineY);
        doc.text("Authorized Signature", signatureX, signatureLineY + 15, { align: 'left' });

        // Open PDF
        const pdfBlobUrl = doc.output('bloburl');
        window.open(pdfBlobUrl, '_blank');
    };

    function calculateFinalPrice(totalPrice, discountPercent) {
        const total = parseFloat(totalPrice) || 0;
        const discount = parseFloat(discountPercent) || 0;
        const discountAmount = total * (discount / 100);
        const finalPrice = total - discountAmount;
        return finalPrice.toFixed(2);
    }

    const handlePrint = () => {
      // Format age display
      const ageYear = formData.ipd_age_year || '';
      const ageMonth = formData.ipd_age_month || '';
      const ageDay = formData.ipd_age_day || '';
      
      let ageDisplay = '';
      if (ageYear) ageDisplay += `${ageYear} Y `;
      if (ageMonth) ageDisplay += `${ageMonth} M `;
      if (ageDay) ageDisplay += `${ageDay} D`;
      ageDisplay = ageDisplay.trim() || '';
  
      const admissionData = {
          uhid: formData.ipd_uhid || '0001',
          patientRegNo: formData.ipd_id || '00010',
          patientName: formData.ipd_patient_name,
          ageGender: `${ageDisplay} / ${formData.ipd_patient_gender}`,
          address: formData.ipd_address,
          phone: formData.ipd_patient_mobile,
          guardian: formData.ipd_guardien_name,
          admissionDate: formData.ipd_reg_date,
          referredDoctor: findNameById(formData.ipd_refer_doctor, formData.docs, 'user_id', 'fname'),
          department: findNameById(formData.ipd_specality, formData.cats, 'cat_id', 'cat_name'),
          caseType: findNameById(formData.ipd_case, formData.cases, 'cat_id', 'cat_name'),
          fileNumber: formData.ipd_file_number,
          payments: [[
              '1.',
              'Emergency / DayCare Fees',
              formData.ipd_pay_mode || 'Cash',
              (parseFloat(formData.ipd_reg_charges) || 0).toFixed(2),
          ]],
          summary: {
              regCharges: parseFloat(formData.ipd_reg_charges) || 0,
              total: parseFloat(formData.ipd_total_price) || 0,
              discount: parseFloat(formData.ipd_total_price - calculateFinalPrice(formData.ipd_total_price, formData.ipd_discount)) || 0,
              paid: parseFloat(formData.ipd_paid) || 0,
              due: parseFloat(formData.ipd_due) || 0,
              final: parseFloat(calculateFinalPrice(formData.ipd_total_price, formData.ipd_discount)) || 0,
          },
      };
  
      generateAdmissionPdf(admissionData);
  };

    const searchUserNow = async (e) => {
        const uhid = e.target.value.trim();

        if (uhid.length < 3) {
            setUhidSuggestions([]);
            return;
        }

        try {
            const fd = new FormData();
            fd.append("lab_reg_uhid", uhid);

            const response = await axios.post(
                AppConst.BASE_URL + AppConst.searchUhidUrlCall,
                fd,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            if (response.data.status) {
                let records = response.data.records || [];

                if (formData.ipd_type === "OPD") {
                    records = records.filter(item => item.lab_reg_type === "OPD");
                } else if (["IPD", "New Visit", "Old"].includes(formData.ipd_type)) {
                    records = records.filter(item => item.lab_reg_type === "IPD");
                }

                setUhidSuggestions(records);
            } else {
                setUhidSuggestions([]);
            }

        } catch (error) {
            console.error("Search Error:", error);
            setUhidSuggestions([]);
        }
    };

    const handleSelIpdUser = async (user) => {
      if (!user) return;
  
      try {
          const fd = new FormData();
          fd.append("lab_reg_uhid", user.lab_reg_uhid);
  
          const response = await axios.post(
              AppConst.BASE_URL + AppConst.searchUhidUrlCall,
              fd,
              { headers: { "Content-Type": "multipart/form-data" } }
          );
  
          if (response.data.status && response.data.records.length > 0) {
              const details = response.data.records[0];
  
              if (details.lab_reg_type === "IPD") {
                  setFormData(prev => ({
                      ...prev,
                      ipd_type: "Old",
                      ipd_uhid: (details.lab_reg_uhid || "").trim(),
                      ipd_patient_name: details.lab_reg_name || "",
                      ipd_patient_gender: details.lab_reg_gender || "",
                      ipd_patient_mobile: details.lab_reg_mobile || "",
                      ipd_address: details.lab_reg_address || "",
                      ipd_city_text: details.lab_reg_city || "",
                      ipd_age_year: details.lab_reg_age_year || "",
                      ipd_age_month: details.lab_reg_age_month || "",
                      ipd_age_day: details.lab_reg_age_day || "",
                      ipd_specality: details.lab_reg_specility || "",
                      ipd_refer_doctor: details.lab_reg_doc || "",
                      ipd_guardien_name: details.lab_guardian_name || "",
                  }));
              } else if (details.lab_reg_type === "OPD") {
                  setFormData(prev => ({
                      ...prev,
                      ipd_type: "OPD",
                      ipd_uhid: (details.lab_reg_uhid || "").trim(),
                      ipd_patient_name: details.lab_reg_name || "",
                      ipd_patient_gender: details.lab_reg_gender || "",
                      ipd_patient_mobile: details.lab_reg_mobile || "",
                      ipd_address: details.lab_reg_address || "",
                      ipd_city_text: details.lab_reg_city || "",
                      ipd_age_year: details.lab_reg_age_year || "",
                      ipd_age_month: details.lab_reg_age_month || "",
                      ipd_age_day: details.lab_reg_age_day || "",
                      ipd_specality: details.lab_reg_specility || "",
                      ipd_refer_doctor: details.lab_reg_doc || "",
                      ipd_guardien_name: details.lab_guardian_name || "",
                  }));
              }
  
              toast.success("Patient data fetched successfully");
          } else {
              toast.error("Patient details not found.");
          }
  
          setUhidSuggestions([]);
      } catch (err) {
          console.error("Error fetching user details for IPD:", err);
          toast.error("Failed to fetch patient data.");
      }
  };

    const calculateDue = (data) => {
        const regVisible = parseFloat(data.ipd_reg_charges) || 0;
        const paid = parseFloat(data.ipd_paid) || 0;
        let due = regVisible - paid;
        return due >= 0 ? due.toFixed(2) : "0.00";
    };

    // Total calc
    useEffect(() => {
        const regOriginal = parseFloat(formData.ipd_reg_charges_original) || 0;
        setFormData(prev => ({
            ...prev,
            ipd_total_price: regOriginal.toFixed(2)
        }));
    }, [formData.ipd_reg_charges_original]);

    // Apply discount
    useEffect(() => {
        try {
            const discPct = parseFloat(formData.ipd_discount) || 0;
            const regOriginal = parseFloat(formData.ipd_reg_charges_original) || 0;

            if (discPct <= 0 || regOriginal <= 0) {
                setFormData(prev => ({
                    ...prev,
                    ipd_reg_charges: regOriginal ? Number(regOriginal).toFixed(2) : prev.ipd_reg_charges
                }));
                return;
            }

            const newReg = regOriginal * (1 - (discPct / 100));
            setFormData(prev => ({
                ...prev,
                ipd_reg_charges: Number(newReg > 0 ? newReg : 0).toFixed(2),
            }));
        } catch (err) {
            console.warn('reg discount effect error', err);
        }
    }, [formData.ipd_discount, formData.ipd_reg_charges_original]);

    // mount useEffect
    useEffect(() => {
        const run = async () => {
            const today = new Date();
            const formatted = today.toISOString().split('T')[0];
            const fileNum = generateFileNumber();
            setFormData(prev => ({ 
                ...prev, 
                ipd_reg_date: formatted,
                ipd_file_number: fileNum
            }));

            const storedData = sessionStorage.getItem("ldata");
            if (storedData) {
                setLdata(JSON.parse(storedData));
            }

            try {
                await initData();
            } catch (err) {
                console.warn('initData failed:', err);
            }

            fetchConfigData();
        };

        run();
    }, []);

    // Prepare options for react-select
    const specialityOptions = useMemo(() => {
      return formData.cats.map(cat => ({
          value: cat.cat_id,
          label: cat.cat_name
      }));
  }, [formData.cats]);

  const doctorOptions = useMemo(() => {
      console.log('Updating doctor options, total docs:', formData.docs.length);
      return formData.docs.map(doc => ({
          value: doc.user_id,
          label: doc.fname
      }));
  }, [formData.docs]);


  const caseOptions = useMemo(() => {
    return formData.cases.map(c => ({
        value: c.cat_id,
        label: c.cat_name
    }));
}, [formData.cases]);
    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xxl-12">
                        <div className="card">
                            <div className="card-body">
                                <h2 style={{ color: "#405189" }}>Emergency / DayCare Registration</h2>
                                <br />
                                <div className="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <br />
                                            </div>
                                            <h5 style={{ color: "#405189" }}>Patient Details</h5>
                                            <br /><br />

                                            <div className={(formData.ipd_type === "Old" || formData.ipd_type === "OPD") ? "col-md-2" : "col-md-4"}>
                                                <div>
                                                    <label className="form-label">Patient Type</label>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            {formData.ipd_remarks === "Moved from OPD" ? (
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={formData.ipd_type}
                                                                    readOnly
                                                                    style={{ backgroundColor: "#eee" }}
                                                                />
                                                            ) : (
                                                                <select
                                                                    className="form-control"
                                                                    name="ipd_type"
                                                                    onChange={handleChange}
                                                                    value={formData.ipd_type}
                                                                >
                                                                    <option value="New Visit">New Visit</option>
                                                                </select>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {(formData.ipd_type === "Old" || formData.ipd_type === "OPD") ?
                                                <div className="col-md-2">
                                                    <div className="mb-3 position-relative">
                                                        <label htmlFor="ipd_uhid_input" className="form-label">UHID</label>
                                                        <input
                                                            type="text"
                                                            id="ipd_uhid_input"
                                                            className="form-control"
                                                            placeholder="Enter UHID"
                                                            name="ipd_uhid"
                                                            onChange={handleChange}
                                                            value={formData.ipd_uhid}
                                                            onKeyUp={
                                                                (formData.ipd_type === "Old" || formData.ipd_type === "OPD")
                                                                    ? searchUserNow
                                                                    : undefined
                                                            }
                                                            autoComplete="off"
                                                            disabled={!(formData.ipd_type === "Old" || formData.ipd_type === "OPD")}
                                                            readOnly={formData.ipd_remarks === "Moved from OPD"}
                                                            style={{
                                                                backgroundColor: formData.ipd_remarks === "Moved from OPD" ? "#eee" : "white"
                                                            }}
                                                        />
                                                        {(formData.ipd_type === "Old" || formData.ipd_type === "OPD") && uhidSuggestions.length > 0 && (
                                                            <ul className="list-group position-absolute w-100" style={{ zIndex: 10 }}>
                                                                {uhidSuggestions.map((user, idx) => (
                                                                    <li
                                                                        key={idx}
                                                                        className="list-group-item list-group-item-action"
                                                                        onClick={() => handleSelIpdUser(user)}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        {user.lab_reg_uhid} - {user.lab_reg_name + user.lab_reg_type}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </div>
                                                </div>
                                                : <></>}

                                            <div className="col-md-4">
                                                <div>
                                                    <label className="form-label">Patient Name</label>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <select className="form-control" name="ipd_patient_title" onChange={handleChange} value={formData.ipd_patient_title}>
                                                                <option value="Mr.">Mr.</option>
                                                                <option value="Mr's">Mr's</option>
                                                                <option value="Miss">Miss</option>
                                                                <option value="Master">Master</option>
                                                                <option value="Baby">Baby</option>
                                                                <option value="Others">Others</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <input type="text" className="form-control" placeholder="Enter Name" name="ipd_patient_name" onChange={handleChange} value={formData.ipd_patient_name} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div>
                                                    <label className="form-label">Gender</label>
                                                    <select className="form-control" name="ipd_patient_gender" onChange={handleChange} value={formData.ipd_patient_gender} style={{ background: "#eeeeee" }}>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                        <option value="Other">Other</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <br />
                                            </div>

                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">Mobile Number</label>
                                                    <input type="text" className="form-control" placeholder="Enter Mobile Number"
                                                        name="ipd_patient_mobile" onChange={handleChange} value={formData.ipd_patient_mobile} />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div>
                                                    <label className="form-label">Guardian</label>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <select className="form-control" name="ipd_guardien_title"
                                                                onChange={handleChange} value={formData.ipd_guardien_title}>
                                                                <option value="C/O">C/O</option>
                                                                <option value="S/O">S/O</option>
                                                                <option value="D/O">D/O</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <input type="text" className="form-control" placeholder="Enter Name" name="ipd_guardien_name"
                                                                onChange={handleChange} value={formData.ipd_guardien_name} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
    <div className="mb-3">
        <label className="form-label">Age</label>
        <input type="hidden" className="form-control"
            name="ipd_reg_date" onChange={handleChange} value={formData.ipd_reg_date} readOnly style={{ background: "#eeeeee" }} />
        <div className="row">
            <div className="col-md-4">
                <input 
                    type="number" 
                    className="form-control" 
                    placeholder="Year"
                    name="ipd_age_year" 
                    onChange={handleChange} 
                    value={formData.ipd_age_year}
                    min="0"
                    max="150"
                    onInput={(e) => {
                        // Ensure value is within range
                        if (e.target.value !== '') {
                            const val = parseInt(e.target.value);
                            if (val < 0) e.target.value = 0;
                            if (val > 150) e.target.value = 150;
                        }
                    }}
                />
                <small className="text-muted">Years</small>
            </div>
            <div className="col-md-4">
                <input 
                    type="number" 
                    className="form-control" 
                    placeholder="Month"
                    name="ipd_age_month" 
                    onChange={handleChange} 
                    value={formData.ipd_age_month}
                    min="0"
                    max="11"
                    onInput={(e) => {
                        // Ensure value is within range
                        if (e.target.value !== '') {
                            const val = parseInt(e.target.value);
                            if (val < 0) e.target.value = 0;
                            if (val > 11) e.target.value = 11;
                        }
                    }}
                />
                <small className="text-muted">Months</small>
            </div>
            <div className="col-md-4">
                <input 
                    type="number" 
                    className="form-control" 
                    placeholder="Day"
                    name="ipd_age_day" 
                    onChange={handleChange} 
                    value={formData.ipd_age_day}
                    min="0"
                    max="30"
                    onInput={(e) => {
                        // Ensure value is within range
                        if (e.target.value !== '') {
                            const val = parseInt(e.target.value);
                            if (val < 0) e.target.value = 0;
                            if (val > 30) e.target.value = 30;
                        }
                    }}
                />
                <small className="text-muted">Days</small>
            </div>
        </div>
    </div>
</div>

                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">Address</label>
                                                    <input type="text" className="form-control" placeholder="Enter Address"
                                                        name="ipd_address" onChange={handleChange} value={formData.ipd_address} />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">City</label>
                                                    <input type="text" className="form-control" placeholder="Enter City"
                                                        name="ipd_city_text" onChange={handleChange} value={formData.ipd_city_text} />
                                                </div>
                                            </div>

                                            {/* Speciality with react-select */}
                                          <div className="col-md-4" ref={specRef}>
                                                <div className="mb-3">
                                                    <label className="form-label">Speciality</label>
                                                    <Select
                                                        options={specialityOptions}
                                                        value={specialityOptions.find(opt => opt.value === formData.ipd_specality) || null}
                                                        onChange={(selected) => {
                                                            console.log('Speciality selected:', selected);
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                ipd_specality: selected ? selected.value : '',
                                                                ipd_refer_doctor: '', // Reset doctor when speciality changes
                                                            }));
                                                        }}
                                                        placeholder="Select Speciality..."
                                                        isClearable
                                                        isSearchable
                                                    />
                                                </div>
                                            </div>

                                            {/* Doctor with react-select */}
                                            <div className="col-md-4" ref={docRef}>
                                                <div className="mb-3">
                                                    <label className="form-label">Referred Doctor</label>
                                                    <Select
                                                        options={doctorOptions}
                                                        value={doctorOptions.find(opt => opt.value === formData.ipd_refer_doctor) || null}
                                                        onChange={(selected) => {
                                                            console.log('Doctor selected:', selected);
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                ipd_refer_doctor: selected ? selected.value : '',
                                                            }));
                                                        }}
                                                        placeholder="Select Doctor..."
                                                        isClearable
                                                        isSearchable
                                                        isDisabled={!formData.ipd_specality} // Disable if no speciality selected
                                                        noOptionsMessage={() => 
                                                            formData.ipd_specality 
                                                                ? "No doctors found for this speciality" 
                                                                : "Please select a speciality first"
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">File Number</label>
                                                    <input type="text" className="form-control" placeholder="Auto Generated"
                                                        name="ipd_file_number" onChange={handleChange} value={formData.ipd_file_number} readOnly style={{ background: "#eeeeee" }} />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">Attachment</label>
                                                    <input type="file" className="form-control"
                                                        name="ipd_attachment" onChange={(e) => {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                ipd_attachmentFile: e.target.files[0]
                                                            }));
                                                        }} />
                                                </div>
                                            </div>

                                            {/* Case with react-select */}
                                            <div className="col-md-4" ref={caseRef}>
                                                <label className="form-label">Case</label>
                                                <Select
                                                    options={caseOptions}
                                                    value={caseOptions.find(opt => opt.value === formData.ipd_case)}
                                                    onChange={(selected) => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            ipd_case: selected ? selected.value : '',
                                                        }));
                                                    }}
                                                    placeholder="Select Case..."
                                                    isClearable
                                                />
                                            </div>

                                            <div className="col-lg-12">
                                                <br /> <br />
                                                <h5 style={{ color: "#405189" }}>Payment Details</h5>
                                                <br />
                                            </div>

                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">Total Price</label>
                                                    <input type="text" className="form-control" name="ipd_total_price"
                                                        value={formData.ipd_total_price} readOnly />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">Discount (%)</label>
                                                    <input type="text" className="form-control" placeholder="Enter discount %"
                                                        name="ipd_discount" onChange={handleChange} value={formData.ipd_discount} />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">Emergency Charges</label>
                                                    <input type="text" className="form-control" placeholder="Emergency Charges"
                                                        name="ipd_reg_charges" onChange={handleChange} value={formData.ipd_reg_charges} readOnly />
                                                </div>
                                            </div>

                                            <div className="col-md-4 d-none">
                                                <div className="mb-3">
                                                    <label className="form-label">Paid</label>
                                                    <input type="text" className="form-control" placeholder="Enter Paid Amount"
                                                        name="ipd_paid" onChange={handleChange} value={formData.ipd_paid} />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">Due</label>
                                                    <input
                                                        type="text"
                                                        name="ipd_due"
                                                        className="form-control"
                                                        value={calculateDue(formData)}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">Payment Mode</label>
                                                    <select className="form-control"
                                                        name="ipd_pay_mode" onChange={handleChange} value={formData.ipd_pay_mode}>
                                                        <option value="cash">Cash</option>
                                                        <option value="online">Online</option>
                                                        <option value="card">Card</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label className="form-label">Remarks</label>
                                                    <textarea
                                                        className="form-control"
                                                        placeholder="Enter Remarks"
                                                        name="ipd_remarks"
                                                        onChange={handleChange}
                                                        value={formData.ipd_remarks}
                                                        rows={4}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-12">
                                                <br /><br />
                                                <div className="text-end">
                                                    <button type="submit" className="btn btn-primary">Save</button>
                                                    &nbsp;&nbsp;&nbsp;
                                                    <button type="button" className="btn btn-dark" disabled={!isSaved} onClick={handlePrint}>Print Invoice</button>
                                                    &nbsp;&nbsp;&nbsp;
                                                    <a href="/emergency_reg" className="btn btn-danger">Cancel</a>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EmergencyRegistrations;